<template>
    <div>
        <ModalBooking
            v-if="profile.services"
            :profile="profile"
            :logo="logo"
            :templateDirectory="templateDirectory"
            :countries="countries"
            :showModal="showModal"
        ></ModalBooking>
        <ModalBookingNew
            v-if="showNewModal"
            :profile="profile"
            :logo="logo"
            :templateDirectory="templateDirectory"
            :countries="countries"
            :showModal="showNewModal"
            :serviceId="selectedBookService"
        ></ModalBookingNew>
        <ModalLogin
            :logo="logo"
            :templateDirectory="templateDirectory"
            :showModal="showLoginModal"
            :getStylistData="getStylistData"
        ></ModalLogin>
        <div class="overlay-show-end loctician-page" v-if="profile.first_name">
            <div class="section stylist-profile-top" :class="{'no-bio': !profile.full_bio, 'template-2':profile.profile_template==2}">
                <div class="_1440-wrap">
                    <div class="profile-info">
                        <div class="profile-info-header">
                            <div class="profile-info-col">
                                <div class="profile-headshot">
                                    <div class="profile-img-wrapper">
                                        <img v-bind:src="(profile.avatar) ? profile.avatar : templateDirectory + '/images/logo-512-512.png'" :alt="`${profile.first_name} ${profile.last_name}`" class="profile-img">
                                    </div>
                                </div>
                                <div class="profile-details">
                                    <div class="stylist-name-wrap">
                                        <h1 class="stylist-name">{{profile.first_name}} {{profile.last_name}} <span v-if="professions.professions.length"> | {{professions.string}}</span></h1>
                                    </div>
                                    <div class="stylist-salon-wrap" v-if="profile.salon || profile.business_name">
                                        <p v-if="!profile.salon_url" class="stylist-salon-name">{{ (profile.salon) ? profile.salon : profile.business_name }}</p>
                                        <a v-if="profile.salon_url" :href="profile.salon_url" target="_blank" class="stylist-salon-name">{{ (profile.salon) ? profile.salon : profile.business_name }}</a>
                                    </div>
                                    <div class="profile-meta-wrap">
                                        <div class="profile-meta-col">
                                            <div class="rating-wrap">
                                                <div v-if="profile_reviews_rate>0">
                                                    <RateStars :rate="(profile_reviews_rate) ? profile_reviews_rate : 0" /> 
                                                    <span class="reviews-count">({{profile.reviews.length}})</span>
                                                </div>
                                            </div>
                                            <div class="profile-likes" v-on:click="updateProfileLikes()">
                                                <img class="like-img" v-bind:src="templateDirectory + '/images/' + like_png" title="Like my portfolio" alt="Like Button" />
                                                <span class="likes-count">{{profile.likes}}</span>
                                            </div>
                                        </div>
                                        <div class="profile-meta-col">
                                            <img v-bind:src="`${api_url}/getprofileqr/${profile.id}?app_id=5&size=150`">
                                        </div>
                                    </div>
                                    <div class="app-links app-links-top-mobile visible-xs">
                                        <p class="download-cta-text">Download our app on your smart phone or tablet</p>
                                        <a rel="noreferrer" v-bind:href="app_links_ios" target="_blank" class="store-btn in-footer w-inline-block"><img v-bind:src="templateDirectory + '/images/App-Store.png'" alt="Download Ring My Stylist App from App Store"></a>
                                        <a rel="noreferrer" v-bind:href="app_links_android" target="_blank" class="store-btn str-btn-google m-r-0 w-inline-block"><img v-bind:src="templateDirectory + '/images/Google-Play.png'" alt="Download Ring My Stylist App from Google Play"></a>
                                    </div>
                                </div>
                            </div>
                            <div class="profile-info-col">
                                <div v-if="profile.work_settings.accept_new_clients==0" class="top-notification">Not accepting new clients. Only book if you are an existing client of mine. Thank you!</div>
                                <div v-if="profile.services.length>0 && profile.profile_template!=2 && profile.profile_template!=3" class="profile-header-services stylist-pro-tab-content">
                                    <h3 class="service-block-title">Services</h3>
                                    <perfect-scrollbar>
                                        <ul class="service-list">
                                            <li class="service-list-item" v-for="service in profile.services">
                                                <div class="service-title">{{service.name}}</div>
                                                <div v-if="service.description" class="service-description">
                                                    {{service.description}}
                                                </div>
                                                <div class="service-meta-wrap">
                                                    <div class="seervice-price">
                                                        {{servicePriceDuration(service.price, service.duration, service.price_and_up)}}
                                                    </div>
                                                    <a href="javascript:void(0);" v-if="profile.accept_website_booking==1" class="book-button w-button" id="show-modal" @click="openNewModal(service.id)">Book Now</a>
                                                </div>
                                            </li>
                                        </ul>
                                    </perfect-scrollbar>
                                </div>
                                <div v-if="profile.services.length==0 && profile.profile_template!=2 && profile.profile_template!=3" class="hours-block-inner">
                                    <h3 class="service-block-title">Working Hours</h3>
                                    <div class="line-sep m-b-50"></div>
                                    <ul class="work-hour-list">
                                        <li v-for="day in days" class="work-hour-list-item">
                                            <div class="service-title">{{day}}</div>
                                            <div class="work-time">{{workTime(profile.work_settings,day)}}</div>
                                        </li>
                                    </ul>
                                </div>
                                <div v-if="randomDisplayImages.length>=1 && profile.profile_template==3" class="gallery-flex-wrap">
                                    <div v-masonry origin-left="true" transition-duration="0.1s" item-selector=".item">
                                        <div v-masonry-tile class="item" v-for="(img, index) in randomDisplayImages">
                                            <div class="gallery-item-w" style="width: 250px; padding: 10px;">
                                                <img v-bind:src="img.image" v-bind:data-src="img.image" :alt="`${profile.first_name} ${profile.last_name} Portfolio ${(index+1)}`">
                                                <div class="picture-likes">
                                                    <a href="javascript:void(0);" v-bind:id="'like_'+profile.id+'_'+img.id" class="like-button" v-bind:class="profile.portfolio_picture_likes.includes(profile.id+':'+img.id) ? 'is-active' : ''" v-bind:data-userid="profile.id" v-bind:data-pictureid="img.id" 
                                                        v-on:click="pictureLikeButton(img.id,profile.portfolio_picture_likes.includes(profile.id+':'+img.id) ? 'is-active' : '')">
                                                        <i class="material-icons not-liked bouncy">favorite_border</i>
                                                        <i class="material-icons is-liked bouncy">favorite</i>
                                                        <span class="like-overlay"></span>
                                                    </a>
                                                    <span v-bind:id="'likes-count-'+profile.id+'-'+img.id" class="likes-count" alt="Like Button">{{img.likes}} {{img.likes == 1 ? 'like' : 'likes'}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-on:click="openImageGallery(0)" class="gallery-view-overlay">
                                        <span>View Portfolio ({{profile.portfolio_images.length}})</span>
                                    </div>
                                </div>
                                <div v-if="profile.profile_template!=2" class="profile-info-col-actions">
                                    <div class="app-links">
                                        <a rel="noreferrer" v-bind:href="app_links_ios" target="_blank" class="store-btn in-footer w-inline-block"><img v-bind:src="templateDirectory + '/images/App-Store.png'" alt="Download Ring My Stylist App from App Store"></a>
                                        <a rel="noreferrer" v-bind:href="app_links_android" target="_blank" class="store-btn str-btn-google m-r-0 w-inline-block"><img v-bind:src="templateDirectory + '/images/Google-Play.png'" alt="Download Ring My Stylist App from Google Play"></a>
                                    </div>
                                    <div class="stylist-social-icons">
                                        <div style="margin-top: 5px;">Share</div>
                                        <a v-bind:href="share.share_twitter" target="_blank" class="styist-social-icon-block w-inline-block"><img v-bind:src="templateDirectory + '/images/twitter-circular-button.svg'" alt="Twitter Share Logo"></a>
                                        <a v-bind:href="share.share_facebook" target="_blank" class="styist-social-icon-block w-inline-block"><img v-bind:src="templateDirectory + '/images/facebook-logo-in-circular-button-outlined-social-symbol.svg'" alt="Facebook Share Logo"></a>
                                    </div>
                                </div>
                                <div v-if="profile.profile_template==2">
                                    <perfect-scrollbar class="profile-bio-top">
                                        <div v-if="profile.full_bio" v-html="profile.full_bio"></div>
                                    </perfect-scrollbar>
                                </div>
                            </div>
                            <div v-if="images.length">
                                <LightBox :images="images" :showLightBox="false" ref="slider"></LightBox>
                            </div>
                        </div>
                        <div class="profile-bio" v-if="profile.full_bio && profile.profile_template!=2" v-html="profile.full_bio"></div>
                        <div v-if="profile.profile_template==2" class="profile-info-col-actions profile-info-col-bottom">
                            <div class="app-links">
                                <a rel="noreferrer" v-bind:href="app_links_ios" target="_blank" class="store-btn in-footer w-inline-block"><img v-bind:src="templateDirectory + '/images/App-Store.png'" alt="Download Ring My Stylist App from App Store"></a>
                                <a rel="noreferrer" v-bind:href="app_links_android" target="_blank" class="store-btn str-btn-google m-r-0 w-inline-block"><img v-bind:src="templateDirectory + '/images/Google-Play.png'" alt="Download Ring My Stylist App from Google Play"></a>
                            </div>
                            <div class="stylist-social-icons">
                                <div style="margin-top: 5px;">Share</div>
                                <a v-bind:href="share.share_twitter" target="_blank" class="styist-social-icon-block w-inline-block"><img v-bind:src="templateDirectory + '/images/twitter-circular-button.svg'" alt="Twitter Share Logo"></a>
                                <a v-bind:href="share.share_facebook" target="_blank" class="styist-social-icon-block w-inline-block"><img v-bind:src="templateDirectory + '/images/facebook-logo-in-circular-button-outlined-social-symbol.svg'" alt="Facebook Share Logo"></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="stylist-profile-tabs w-tabs">
                <div v-if="profile.profile_template>=2" class="stylist-profile-tabs-menu w-tab-menu">
                    <div class="container">
                        <a data-tab="tab1" v-bind:class="{ 'w--current':(!reviewsTab && (profile.profile_template==2 || profile.profile_template==3)) }" class="profile-tab-link profile-tab-link-services w-inline-block w-tab-link tab1">
                            <div>Services</div>
                        </a>
                        <a data-tab="tab2" v-bind:class="{ 'w--current':(!reviewsTab && profile.profile_template!=2 && profile.profile_template!=3) }" class="profile-tab-link w-inline-block w-tab-link tab2">
                            <div>Hours &amp; Location</div>
                        </a>
                        <a data-tab="tab3" class="profile-tab-link w-inline-block w-tab-link tab3">
                            <div>Portfolio<span v-if="profile.portfolio_images" class="portfolio-count ">({{profile.portfolio_images.length}})</span></div>
                        </a>
                        <a data-tab="tab4" :class="{'w--current':reviewsTab}" class="profile-tab-link w-inline-block w-tab-link  tab4">
                            <div>
                                Reviews 
                                <RateStars :rate="profile_reviews_rate" />
                                <span v-if="profile.reviews" class="reviews-count">({{profile.reviews.length}})</span>
                            </div>
                        </a>
                    </div>
                </div>

                <div v-if="profile.profile_template<2" class="stylist-profile-tabs-menu w-tab-menu">
                    <div class="container">
                        <a data-tab="tab2" v-on:click="scrollToSection('#tab2')" v-bind:class="{ 'w--current':(!reviewsTab && profile.profile_template!=2 && profile.profile_template!=3) }" class="profile-tab-link w-inline-block w-tab-link tab2">
                            <div>Hours &amp; Location</div>
                        </a>
                        <a data-tab="tab3" v-on:click="scrollToSection('#tab3')" class="profile-tab-link w-inline-block w-tab-link tab3">
                            <div>Portfolio<span v-if="profile.portfolio_images" class="portfolio-count ">({{profile.portfolio_images.length}})</span></div>
                        </a>
                        <a data-tab="tab4" v-on:click="scrollToSection('#tab4')" :class="{'w--current':reviewsTab}" class="profile-tab-link w-inline-block w-tab-link  tab4">
                            <div>
                                Reviews 
                                <RateStars :rate="profile_reviews_rate" />
                                <span v-if="profile.reviews" class="reviews-count">({{profile.reviews.length}})</span>
                            </div>
                        </a>
                        <a data-tab="tab1" v-on:click="scrollToSection('#tab1')" v-bind:class="{ 'w--current':(!reviewsTab && (profile.profile_template==2 || profile.profile_template==3)) }" class="profile-tab-link profile-tab-link-services w-inline-block w-tab-link tab1">
                            <div>Services</div>
                        </a>
                    </div>
                </div>

                <div class="stylist-pro-tab-content" :class="{'w-tab-content':(profile.profile_template>=2)}">
                    <!-- 2 -->
                    <div data-w-tab="Tab 2" id="tab2" :class="{'w-tab-pane':(profile.profile_template>=2), 'w--tab-active':(!reviewsTab && profile.profile_template!=2 && profile.profile_template!=3)}">
                        <div class="tab-pane-inner">
                            <div class="hours-flex-wrap">
                                <div class="hours-block">
                                    <div class="hours-block-inner">
                                        <h3 class="service-block-title">Working Hours</h3>
                                        <div class="line-sep m-b-50"></div>
                                        <ul class="work-hour-list">
                                            <li v-for="day in days" class="work-hour-list-item">
                                                <div class="service-title">{{day}}</div>
                                                <div class="work-time">{{workTime(profile.work_settings,day)}}</div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div v-if="profile.has_address" class="map-wrap">
                                    <h3 class="service-block-title">Location</h3>
                                    <div class="line-sep m-b-50"></div>
                                    <div id="map" class="work-location-map map-wrapper"></div>
                                    <div class="business-adress-wrap text-left">
                                        <a class="business-adress-link" target="_blank" :href="`https://www.google.com/maps/search/?api=1&query=${profile.address}%20${profile.city}%20${profile.state}%20${profile.zip}%20`">
                                            <div>{{profile.address}}</div>
                                            <div><span v-if="profile.city">{{profile.city}}, </span> <span v-if="profile.state">{{profile.state}} </span> <span v-if="profile.zip">{{profile.zip}}</span></div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div v-if="profile.profile_template>=2" class="download-app-box">
                                <div class="app-links">
                                    <h2 class="app-links-text">Download the app!</h2>
                                    <a rel="noreferrer" v-bind:href="app_links_ios" target="_blank" class="store-btn in-footer w-inline-block"><img v-bind:src="templateDirectory + '/images/App-Store.png'" alt="Download Ring My Stylist App from App Store"></a>
                                    <a rel="noreferrer" v-bind:href="app_links_android" target="_blank" class="store-btn str-btn-google m-r-0 w-inline-block"><img v-bind:src="templateDirectory + '/images/Google-Play.png'" alt="Download Ring My Stylist App from Google Play"></a>
                                </div>
                            </div>
                            <div v-if="profile.services.length && profile.accept_website_booking==1 && profile.profile_template>=2" class="book-btn-block">
                                <div class="cta-text">Book an appointment with me!</div>
                                <a href="#" class="book-button w-button" id="show-modal" @click="openNewModal">Book Now</a>
                            </div>
                        </div>
                    </div>

                    <!-- 3  v-bind:alt="profile.first_name profile.last_name+' Profile Gallery Image ' +imageContor" v-bind:title="profile.first_name profile.last_name +'Profile Gallery Image'+ imageContor" -->
                    <div data-w-tab="Tab 3" id="tab3" :class="{'w-tab-pane':(profile.profile_template>=2)}">
                        <div class="tab-pane-inner">
                            <div class="gallery-flex-wrap">
                                <div v-if="images.length">
                                    <span v-if="img.image.length" v-for="(img, index) in profile.portfolio_images" :key="index" class="portfolio-img-wrapper">
                                        <a style="display:none2" v-on:click="openImageGallery(index)" href="#" class="gallery-link w-inline-block w-lightbox">
                                            <img v-bind:src="img.image" v-bind:data-src="img.image" :alt="`${profile.first_name} ${profile.last_name} Portfolio ${(index+1)}`"><script type="application/json" class="w-json">{
                                                "items": [
                                                  {
                                                    "width": 1280,
                                                    "caption": "",
                                                    "height": 800,
                                                    "fileName": "attractive-beautiful-beautiful-girl-458766.jpg",
                                                    "origFileName": "attractive-beautiful-beautiful-girl-458766.jpg",
                                                    "url": "img.image",
                                                    "_id": "5bc3f59cca643a34eb2f12eb",
                                                    "type": "image",
                                                    "fileSize": 138849
                                                  }
                                                ],
                                                "group": "portfolio"
                                                }
                                            </script>
                                        </a>
                                        <div class="picture-likes">
                                            <a href="javascript:void(0);" v-bind:id="'like_'+profile.id+'_'+img.id" class="like-button" v-bind:class="profile.portfolio_picture_likes.includes(profile.id+':'+img.id) ? 'is-active' : ''" v-bind:data-userid="profile.id" v-bind:data-pictureid="img.id" 
                                                v-on:click="pictureLikeButton(img.id,profile.portfolio_picture_likes.includes(profile.id+':'+img.id) ? 'is-active' : '')">
                                                <i class="material-icons not-liked bouncy">favorite_border</i>
                                                <i class="material-icons is-liked bouncy">favorite</i>
                                                <span class="like-overlay"></span>
                                            </a>

                                            <span v-bind:id="'likes-count-'+profile.id+'-'+img.id" class="likes-count" alt="Like Button">{{img.likes}} {{img.likes == 1 ? 'like' : 'likes'}}</span>
                                        </div>
                                    </span>
                                </div>
                                <div v-else>
                                    <h3 class="placeholder-text">No Portfolio Images</h3>
                                </div>
                            </div>
                            <div v-if="profile.profile_template>=2" class="download-app-box">
                                <div class="app-links">
                                    <h2 class="app-links-text">Download the app!</h2>
                                    <a rel="noreferrer" v-bind:href="app_links_ios" target="_blank" class="store-btn in-footer w-inline-block"><img v-bind:src="templateDirectory + '/images/App-Store.png'" alt="Download Ring My Stylist App from App Store"></a>
                                    <a rel="noreferrer" v-bind:href="app_links_android" target="_blank" class="store-btn str-btn-google m-r-0 w-inline-block"><img v-bind:src="templateDirectory + '/images/Google-Play.png'" alt="Download Ring My Stylist App from Google Play"></a>
                                </div>
                            </div>
                            <div v-if="profile.services.length && profile.accept_website_booking==1 && profile.profile_template>=2" class="book-btn-block">
                                <div class="cta-text">Book an appointment with me!</div>
                                <a href="#" class="book-button w-button" id="show-modal" @click="openNewModal">Book Now</a>
                            </div>
                        </div>
                    </div>

                    <div data-w-tab="Tab 4" id="tab4" :class="{'w-tab-pane':(profile.profile_template>=2), 'w--tab-active':reviewsTab}">
                        <div class="tab-pane-inner">
                            <div class="reviews-wrap">
                                <div class="logout-row text-right">
                                    <a v-if="logged_in_user==true" v-on:click="logoutAppUser" href="javascript:void(0)" id="rms-logout">Logout</a>
                                    <a v-else href="javascript:void(0)" class="rms-login-link">Login</a>
                                </div>

                                <div class="profile-reviews-wrap">
                                    <div v-if="logged_in_user==false" id="login-form" class="login-form-wrap hidden">
                                        <div class="login-section">
                                            <form method="POST">
                                                <h3 class="login-form-headline">Login with your account</h3>
                                                <div class="line-sep m-b-50"></div>

                                                <div class="login-form-row input-row email-login-row">
                                                    <span class="login-form-field-icon login-icon"></span>
                                                    <input id="email-login" type="text" v-model="email" name="email" placeholder="Login" />
                                                </div>

                                                <div class="login-form-row input-row password-login-row">
                                                    <span class="login-form-field-icon password-icon"></span>
                                                    <input id="password-login" type="password" v-model="password" name="password" placeholder="Password" />
                                                </div>
                                                <div class="login-form-row links-row text-right">
                                                    <a v-bind:href="forgot_pass_url" target="_blank">Forgot password?</a>
                                                </div>

                                                <div class="row login-form-row">
                                                    <div id="rms-login-messages" class="col-sm-12">
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-4">
                                                        <input @click="loginAppUser" type="button" id="rms-login-button" class="login-button" name="login" value="Login">
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div class="login-section with-background">
                                            <h3 class="login-form-headline">Get started with your free account!</h3>
                                            <div class="line-sep m-b-40"></div>
                                            <div class="login-form-details">
                                                <p>
                                                    Find your stylist. Book your appointments. Rate your stylist. Write reviews. Do it all with Ring My Stylist.'<br>
                                                    <a target="_blank" v-bind:href="openapp">Click here to download the app.</a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="logged_in_user==false && token==null">
                                        <a href="javascript:void(0);" class="rms-login-link">{{profile.reviews.length ? 'Write a review for' : 'Be the first one to write a review for'}} {{profile.first_name}}</a>
                                    </div>
                                    <div v-else>
                                        <div class="review-form-wrap">
                                            <form id="review-form" v-bind:action="submit_profile_review" v-if="!profile_review_submitted" method="post">
                                                <div class="row form-row">
                                                    <div class="col-xs-12"><label for="review-rating">Rating</label></div>
                                                    <div class="col-xs-12">
                                                        <select id="review-rating" v-model="reviewRating" name="review-rating">
                                                            <option>5</option><option>4</option><option>3</option><option>2</option><option>1</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row form-row">
                                                    <div class="col-xs-12"><label for="review-title">Review Title</label></div>
                                                    <div class="col-xs-12"><input id="review-title" v-model="reviewTitle" type="text" name="review-title" /></div>
                                                </div>
                                                <div class="row form-row">
                                                    <div class="col-xs-12"><label for="review-text">Review</label></div>
                                                    <div class="col-xs-12"><textarea id="review-text" v-model="reviewText" name="review-text"></textarea></div>
                                                </div>
                                                <div class="row form-row">
                                                    <div class="col-xs-12">
                                                        <input type="button" @click="submitProfileReview" id="submit-review" class="login-button" name="submit" value="Submit Review">
                                                    </div>
                                                </div>
                                            </form>
                                            <div class="row form-row">
                                                <div id="rms-review-messages" class="col-sm-12"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="reviews-count">{{profile.reviews.length}} review(s)</div>

                                    <div class="review-items">
                                        <div v-for="review in profile.reviews" class="review-item">
                                            <div class="review-item-headline">
                                                <span class="review-item-rating">
                                                    <span v-for="rate in review.rate" class="review-item-star"></span>
                                                </span>
                                                <h4 class="review-item-title">{{review.title}}</h4>
                                            </div>
                                            <div class="review-item-details">
                                                {{review.details}}
                                            </div>
                                            <div class="review-item-meta">
                                                <span v-if="review.ebs==0">{{review.first_name.charAt(0).toUpperCase() + review.first_name.slice(1)}} {{review.last_name.charAt(0).toUpperCase() + review.last_name.slice(1)}}</span>
                                                <span v-if="review.ebs==0" class="review-item-meta-separator"></span>
                                                {{ review.created_at | moment("LL") }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="profile.profile_template>=2" class="download-app-box">
                                <div class="app-links">
                                    <h2 class="app-links-text">Download the app!</h2>
                                    <a rel="noreferrer" v-bind:href="app_links_ios" target="_blank" class="store-btn in-footer w-inline-block"><img v-bind:src="templateDirectory + '/images/App-Store.png'" alt="Download Ring My Stylist App from App Store"></a>
                                    <a rel="noreferrer" v-bind:href="app_links_android" target="_blank" class="store-btn str-btn-google m-r-0 w-inline-block"><img v-bind:src="templateDirectory + '/images/Google-Play.png'" alt="Download Ring My Stylist App from Google Play"></a>
                                </div>
                            </div>
                            <div v-if="profile.services.length && profile.accept_website_booking==1 && profile.profile_template>=2" class="book-btn-block">
                                <div class="cta-text">Book an appointment with me!</div>
                                <a href="#" class="book-button w-button" id="show-modal" @click="openNewModal">Book Now</a>
                            </div>
                        </div>
                    </div>

                    <div data-w-tab="Tab 1" id="tab1" :class="{'w-tab-pane':(profile.profile_template>=2), 'w--tab-active':(!reviewsTab && (profile.profile_template==2 || profile.profile_template==3))}">
                        <div class="tab-pane-inner">
                            <div class="stylist-services-wrapper">
                                <div v-if="profile.categories.length">

                                        <!-- <div v-if="categoryContor%3==1"> -->
                                            <div class="stylist-services-wrap">
                                                <div v-for="category in profile.categories" v-if="category.services.length>0 || !category.id" class="stylist-services-block" v-bind:class="{'full-width': profile.categories.length==1}">
                                                    <div class="stylist-service-block-inner">
                                                        <h3 class="service-block-title">{{category.name}}</h3>
                                                        <div class="line-sep"></div>
                                                        <ul class="service-list">
                                                            <li class="service-list-item" v-for="service in category.services">
                                                                <div class="service-title">{{service.name}}</div>
                                                                <div v-if="service.description" class="service-description">
                                                                    {{service.description}}
                                                                </div>
                                                                <div class="service-meta-wrap">
                                                                    <div class="seervice-price">
                                                                        {{servicePriceDuration(service.price,service.duration, service.price_and_up)}}
                                                                    </div>
                                                                    <a href="javascript:void(0);" v-if="profile.accept_website_booking==1" class="book-button w-button" id="show-modal" @click="openNewModal(service.id)">Book Now</a>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        <!-- </div> -->
                                </div>
                                <div v-else>
                                    <div class="stylist-services-block" style="flex-basis: 100%; ">
                                        <div class="stylist-service-block-inner">
                                            <h3 class="service-block-title">No Services</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="download-app-box">
                                <div class="app-links">
                                    <h2 class="app-links-text">Download the app!</h2>
                                    <a rel="noreferrer" v-bind:href="app_links_ios" target="_blank" class="store-btn in-footer w-inline-block"><img v-bind:src="templateDirectory + '/images/App-Store.png'" alt="Download Ring My Stylist App from App Store"></a>
                                    <a rel="noreferrer" v-bind:href="app_links_android" target="_blank" class="store-btn str-btn-google m-r-0 w-inline-block"><img v-bind:src="templateDirectory + '/images/Google-Play.png'" alt="Download Ring My Stylist App from Google Play"></a>
                                </div>
                            </div>
                            <div v-if="profile.services.length && profile.accept_website_booking==1" class="book-btn-block">
                                <div class="cta-text">Book an appointment with me!</div>
                                <a href="#" class="book-button w-button" id="show-modal" @click="openNewModal">Book Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import $ from 'jquery'
    import _ from 'lodash'
    import {eventBus} from "../main"
    import RateStars from "./RateStars"
    import LightBox from 'vue-image-lightbox'
    import ModalBooking from '@/components/ModalBooking.vue'
    import ModalBookingNew from '@/components/ModalBookingNew.vue'
    import ModalLogin from '@/components/ModalLogin.vue'
    import {VueMasonryPlugin} from 'vue-masonry';
    import PerfectScrollbar from "vue2-perfect-scrollbar";
    import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

    Vue.use(PerfectScrollbar);
    Vue.config.productionTip = false;
    Vue.use(VueMasonryPlugin);

    export default {
        name: 'StylistProfileTop',
        components: {
            LightBox,
            ModalBooking,
            ModalBookingNew,
            ModalLogin,
            RateStars,
        },
        data() {
            return {
                loading: true,
                templateDirectory: document.getElementById("template_directory").value,
                app_links_android: document.getElementById("app_links_android").value,
                app_links_ios: document.getElementById("app_links_ios").value,
                admin_url: document.getElementById('admin_url').value,
                stylist_alias: document.getElementById('stylist_alias').value,
                rms_stylist_list_page: document.getElementById('rms_stylist_list_page').value,
                api_url: document.getElementById('api_url').value,
                like_png: 'like-rmb.png',
                like_png_full: 'like-rmb-full.png',
                logo: 'loctician-logo-349-70.png',
                profile: {},
                share: {},
                professions: {},
                days: ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'],
                countries: {},
                showModal: false,
                showNewModal: false,
                showLoginModal: false,

                categoryContor: 0,
                imageContor: 0,
                logged_in_user: false,
                login_app_user: '',
                openapp: 'https://api.ringmyloctician.com/openapp',
                forgot_pass_url: 'https://book.ringmyloctician.com/admin/forgot-password',
                submit_profile_review: '',

                images: [],

                email: '',
                password: '',

                reviewRating: '',
                reviewTitle: '',
                reviewText: '',

                token: null,
                profile_review_submitted: false,
                profile_reviews_rate: 0,
                display_full_bio: false,
                reviewsTab: false,
                randomDisplayImages: [],
            }
        },
        props: {},
        created () {
            this.getStylistData()
            eventBus.$on('updateShowModalState', (state) => {
                this.showModal = state;
                this.showNewModal = state;
                this.showLoginModal = state;
                let className = (state) ? 'stylist-profile modal-open' : 'stylist-profile';
                document.body.className = className;
            });

            eventBus.$on('userLoggedIn', (state) => {
                this.getStylistData();
            });

            var url_string = window.location.href
            var url = new URL(url_string);
            var token = url.searchParams.get("token");
            
            if(token!=null) {
                this.token = token;
            }

            this.reviewsTab = (window.location.hash == '#reviews');
        },

        mounted() {
            $('body').find('.footer').show();

            $('body').on('click','.profile-tab-link',function(e){
                if ( !$(this).hasClass("w--current") ) {
                    $('.profile-tab-link').removeClass('w--current')
                    $(this).addClass('w--current')

                    var tab = $(this).data('tab')
                    $('.w-tab-pane').removeClass('w--tab-active')
                    $('#'+tab).addClass('w--tab-active');
                }
            });

            $('body').on('click','.rms-login-link', function(e){
                $('.login-form-wrap').removeClass('hidden')
                $('.rms-login-link').addClass('hidden')
            });

            let self = this;
            $('body').on('click','.profile-bio-readmore',function(e){
                self.display_full_bio = true;
            });

            $(window).on('load', _.debounce(() => {
                this.initMap();
                $('.loadingoverlay').hide();

                if(this.token!=null) {
                    $('.profile-tab-link').removeClass('w--current')
                    $('.tab4').addClass('w--current')

                    $('.w-tab-pane').removeClass('w--tab-active')
                    $('#tab4').addClass('w--tab-active');
                } 
            }, 1000));

            window.onload = function() {
                $('.overlay-show-end').css('opacity', '1');
                $('div[data-w-id="98da6b66-394f-4597-a90b-f52e4251cb58"]').show();
            };

            $(window).on('resize', _.debounce(() => {
                this.$redrawVueMasonry();
                console.log('here');
            }, 500));
        },

        methods: {
            pictureLikeButton(picture_id, is_active) {
                var picture_likes = this.getCookie('portfolio_picture_likes');
                var likes = picture_likes.split(',');
                if(likes.indexOf(""+this.profile.id+':'+picture_id) != -1 || is_active=='is-active') {
                    return;
                }

                picture_likes += (picture_likes.length) ? ','+this.profile.id+':'+picture_id : this.profile.id+':'+picture_id;
                this.setCookie('portfolio_picture_likes', picture_likes, 365);

                var data = new FormData();
                data.append('action', 'update_picture_likes');
                data.append('user_id', this.profile.id);
                data.append('picture_id', picture_id);

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            
                        }else{
                            var label = (response.data.likes == 1) ? 'like':'likes';
                            $('#likes-count-' + this.profile.id + '-' + picture_id).text( response.data.likes+' '+label );
                            $('#like_'+this.profile.id+'_'+picture_id).addClass('is-active');
                        }
                    });
            },

            getStylistData() {
                var data = new FormData();
                data.append('action', 'get_stylist_profile_data');
                data.append('stylist_alias', this.stylist_alias);

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            this.profile = response.data.profile
                            this.share = response.data.share
                            this.professions = response.data.professions
                            this.logged_in_user = response.data.logged_in_user
                            this.login_app_user = response.data.login_app_user
                            this.submit_profile_review = response.data.submit_profile_review
                            this.images = response.data.profile.portfolio_images_vue
                            this.countries = response.data.countries

                            if(this.profile.reviews) {
                                let total_rate = 0;
                                this.profile.reviews.forEach(function(el){
                                    total_rate += el.rate;
                                });

                                this.profile_reviews_rate = total_rate / this.profile.reviews.length;
                            }

                            if(this.profile.portfolio_images && this.profile.portfolio_images.length > 4) {
                                let numbers = this.getRandomIntegers(0, this.profile.portfolio_images.length-1, 4);
                                this.randomDisplayImages = [];

                                numbers.forEach((i) => {
                                    this.randomDisplayImages.push( this.profile.portfolio_images[i] );
                                });
                            } else {
                                this.randomDisplayImages = this.profile.portfolio_images;
                            }

                            if(this.reviewsTab && this.profile.profile_template < 2) {
                                setTimeout(()=>{
                                    this.scrollToSection('#tab4');
                                }, 1000);
                            }
                        }
                    });
            },

            getRandomIntegers(min, max, number) {
                var numbers = [];

                for(let i=0; i<number; i++){
                    var num = Math.floor(Math.random() * (max - min + 1) ) + min;

                    if(numbers.indexOf(num) == -1) {
                        numbers.push(num);
                    } else {
                        while(numbers.indexOf(num) != -1) {
                            num = Math.floor(Math.random() * (max - min + 1) ) + min;

                            if(numbers.indexOf(num) == -1) {
                                numbers.push(num);
                                break;
                            }
                        }
                    }
                }

                return numbers;
            },

            updateProfileLikes() {
                var data = new FormData();
                data.append('action', 'update_profile_likes');
                data.append('user_id', this.profile.id);
                data.append('vue','true');

                var profile_likes = this.getCookie('profile_likes');
                var likes = profile_likes.split(',');

                if(likes.indexOf(""+this.profile.id) != -1) { 
                    return;
                }

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            this.profile.likes = response.data.likes
                            profile_likes += (profile_likes.length) ? ','+this.profile.id : this.profile.id;
                            this.setCookie('profile_likes', profile_likes, 365);
                        }
                    });
            },

            loginAppUser(e) {
                var data = new FormData();
                data.append('action', 'login_app_user');
                data.append('email', this.email);
                data.append('password', this.password);

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(response.data.error==true) {
                                $('#rms-login-messages').html('<div class="alert alert-danger">'+response.data.message+'</div>');
                            } else {
                                $('#rms-login-messages').html('<div class="alert alert-success">'+response.data.message+'</div>');
                                this.getStylistData()
                            }
                        }
                    });
                e.preventDefault();
            },

            logoutAppUser(e) {
                var data = new FormData();
                data.append('action', 'logout_app_user');

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(response.data.error==true) {
                                $('#rms-login-messages').html('<div class="alert alert-danger">'+response.data.message+'</div>');
                            } else {
                                $('#rms-login-messages').html('<div class="alert alert-success">'+response.data.message+'</div>');
                                this.getStylistData()
                            }
                        }
                    });
                e.preventDefault();
            },

            submitProfileReview(e) {
                var data = new FormData();
                data.append('action', 'submit_profile_review');
                data.append('rating', this.reviewRating);
                data.append('title', this.reviewTitle);
                data.append('text', this.reviewText);
                data.append('user_id', this.profile.id);
                data.append('review_token', (this.token) ? this.token : '');

                this.$http.post(this.admin_url,data)
                    .then(response => {
                        if(response.error == true){
                            alert('error');
                        }else{
                            if(response.data.error==true) {
                                $('#rms-review-messages').html('<div class="alert alert-danger">'+response.data.message+'</div>');
                            } else {
                                $('#rms-review-messages').html('<div class="alert alert-success">'+response.data.message+'</div>');
                                this.reviewRating = '';
                                this.reviewTitle = '';
                                this.reviewText = '';
                                this.getStylistData()
                                this.profile_review_submitted = true;
                            }
                        }
                    });
                e.preventDefault();
            },

            getCookie(cname) {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');

                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                        c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            },

            setCookie(cname, cvalue, exdays) {
                var d = new Date();
                d.setTime(d.getTime() + (exdays*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            },

            counterPlus() {
                this.categoryContor++
            },

            counterImg() {
                this.imageContor++
            },

            servicePriceDuration(service_price,service_duration,price_and_up) {
                if((this.profile.currency!='' && this.profile.currency!='USD')) {
                    service_price = service_price + ' ' + this.profile.currency;
                } else {
                    service_price = '$' + service_price;
                }

                service_price = (!service_price || this.profile.display_prices==0) ? '' : service_price + ((price_and_up) ? ' and up, ' : ', ');
                service_duration = (service_duration && this.profile.display_hours==1) ? service_duration + ' minutes' : '';
                return service_price + service_duration;
            },

            workTime(settings,day) {
                return settings[day]=="" ? 'OFF' : settings[day+'_from'] + ' - ' + settings[day+'_to']
            },

            initMap() {
                var map_el = document.getElementById('map');

                if(map_el == null){
                    return;
                }

                var map = new google.maps.Map(map_el, {
                    zoom: 15,
                    disableDefaultUI: true,
                    center: {lat: -34.397, lng: 150.644}
                });
                var geocoder = new google.maps.Geocoder();
                var address = this.profile.address + ', ' + this.profile.city + ', ' + this.profile.state + ', ' + this.profile.zip;

                geocoder.geocode({'address': address}, function(results, status) {
                    if (status === 'OK') {
                        map.setCenter(results[0].geometry.location);
                        var marker = new google.maps.Marker({
                            map: map,
                            position: results[0].geometry.location
                        });
                    }
                });
            },

            openImageGallery(index) {
                this.$refs.slider.showImage(index);
            },

            openModal: function() {
                this.showModal = true;
                document.body.className = 'stylist-profile modal-open';
            },

            openNewModal: function(service_id) {
                this.showNewModal = true;
                this.selectedBookService = service_id;
                document.body.className = 'stylist-profile modal-open';
            },

            scrollToSection(section_id) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(section_id).offset().top - 100
                }, 1000);
            },
        },
    }
</script>

<style>
.stylist-profile-tabs-menu, .gallery-flex-wrap, .service-list, .service-title, .reviews-wrap, .profile-bio, .service-block-title{
    text-align:left;
}

.stylist-profile-tabs-menu.profile-services-fixed-top {
    max-width: 100%;
}

.stylist-profile-tabs-menu .container {
    position: relative;
}

.stylist-profile-tabs-menu.profile-services-fixed-top .book-appt-block {
    top: 7px;
}

.stylist-service-block-inner{
    height: 100%;
}

.profile-img-wrapper{
    position:relative;
    width:200px;
    height:200px;
    overflow:hidden;
    border-radius:100%;
}

.profile-img-wrapper .profile-img{
    position:absolute;
    width:100% !important;
    height: auto !important;
    min-height:100%;
    top:0;
    left:0;
    bottom: 0;
    margin: auto;
}

.service-title {
    text-transform: capitalize;
}

.book-appt-top {
    margin: 15px 0;
}

.header.w-nav {
    position: relative !important;
    background-color: #1f1f1f;
}

.section.stylist-profile-top .profile-info {
    display: block;
}

.section.stylist-profile-top .profile-headshot {
    margin-bottom: 20px;
    margin-right: 0;
}

.section.stylist-profile-top.no-bio {
    padding-bottom: 20px;
}

.profile-header-services .service-block-title {
    margin-top: 0;
    margin-left: 10px;
}

.profile-header-services.stylist-pro-tab-content {
    background-color: transparent;
}

.profile-header-services .service-list {
    padding: 0 20px 0 10px;
    margin-top: 10px;
}

.profile-header-services .ps {
    height: 500px;
    margin-bottom: 20px;
}

a.stylist-salon-name {
    color: #000000;
}

.app-links-top-mobile {
    margin: 15px 0 0;
    padding: 10px 0 15px;
    border-top: 2px solid #ccc;
    border-bottom: 2px solid #ccc;
}

.download-cta-text {
    color: #000000;
}

.profile-meta-wrap {
    display: flex;
    align-items: center;
}

.profile-meta-wrap .profile-meta-col {
    width: 50%;
}

.top-notification {
    margin-bottom: 25px;
    font-size: 22px;
    line-height: 25px;
    text-align: left;
    color: #00008d;
}

@media (min-width: 992px){
    .profile-info .profile-bio {
        min-height: auto;
        margin-bottom: 0;
    }
}

@media (max-width: 991px){
    .stylist-services-block.full-width .service-list .service-list-item {
        width: 50% !important;
    }
}

@media (max-width: 767px){
    .modal-dialog {
        max-height: 90vh;
        overflow: auto;
    }

    .gallery-item-w {
        width: 290px !important;
    }

    .stylist-services-block.full-width .service-list .service-list-item {
        width: 100% !important;
    }

    .stylist-pro-tab-content .stylist-services-block.full-width .service-meta-wrap {
        padding-right: 0 !important;
    }
}

@media (max-width: 479px) {
    .invite-phone-wrapper #phone-3 {
        width: 55px;
    }
}
</style>